import React, { useState, useEffect } from 'react';
import { Button } from '@/components/shared';

interface BackToTopButtonProps {
    className?: string;
}

export const BackToTopButton: React.FC<BackToTopButtonProps> = ({ className = '' }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            // Show button after scrolling past 800px (roughly past the path selector)
            if (window.pageYOffset > 800) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    if (!isVisible) {
        return null;
    }

    return (
        <Button
            variant="custom"
            onClick={scrollToTop}
            className={`
                fixed bottom-8 right-8 z-50 w-12 h-12 bg-bibi-blue hover:bg-bibi-blue/90 
                text-white rounded-full shadow-lg transition-all duration-300 transform hover:scale-110
                focus:outline-none focus:ring-4 focus:ring-bibi-blue/50
                ${className}
            `}
            aria-label="Back to top"
        >
            <svg
                className="w-6 h-6 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 10l7-7m0 0l7 7m-7-7v18"
                />
            </svg>
        </Button>
    );
};
